import LoadingButton from '@/common/components/base/button/loadingButton';
import TextareaInput from '@/common/components/base/textarea/textareaInput/TextInput';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import FixToBottom from '@/common/components/layouts/FixToBottom';
import MainLayout from '@/common/components/layouts/MainLayout';
import LoadingPage from '@/common/pages/LoadingPage';
import { AdjusterOpinionFormType } from '@/modules/adjusterReportModules/adjusterReport/pages/adjusterOpinion/adjusterOpinion.type';
import { getAdjusterOpinionQueryOptions } from '@/modules/adjusterReportModules/adjusterReport/queries/adjusterOpinion/getAdjusterOpinion/getAdjusterOpinionQueryOptions';
import { postAdjusterOpinionQueryOptions } from '@/modules/adjusterReportModules/adjusterReport/queries/adjusterOpinion/postAdjusterOpinion/postAdjusterOpinionQueryOptions';
import { fileDetailQueryOption } from '@/modules/FileList/queries/fileDetail/fileDetailQueryOption';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="نظر کارشناسی" header="titleHeader">
      <AdjusterOpinion />
    </MainLayout>
  );
};
const AdjusterOpinion = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const methods = useForm<AdjusterOpinionFormType>({
    defaultValues: { accident_description: '', adjuster_opinion: '' },
  });
  const { data: fileDetail, isPending: loading } = useQuery(
    fileDetailQueryOption({ id: +id! }),
  );

  const { isPending: getAdjusterOpinionLoading } = useQuery(
    getAdjusterOpinionQueryOptions({
      id: id!,
      onSuccess: (data) => {
        methods.reset(data);
      },
    }),
  );
  const { mutateAsync, isPending: postLoading } = useMutation(
    postAdjusterOpinionQueryOptions(),
  );

  const onSubmit = (data: AdjusterOpinionFormType) => {
    mutateAsync({ data, id: id! }).then(() => {
      queryClient
        .invalidateQueries({
          queryKey: getAdjusterOpinionQueryOptions({ id: id! }).queryKey,
        })
        .then(() => {
          navigate(-1);
        });
    });
  };
  if (getAdjusterOpinionLoading || loading) {
    return <LoadingPage />;
  }
  return (
    <Box pt="2rem">
      <TitleDescription>
        پس از بررسی پرونده، در صورت تمایل نظر کارشناسی خود را ثبت نمایید.
      </TitleDescription>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Flex flexDirection="column" mt="3rem">
            {fileDetail?.fileType === 'initial' ? (
              <TextareaInput
                rules={{
                  required: {
                    value: true,
                    message: 'شرح بازدید را وارد نمایید',
                  },
                }}
                name="accident_description"
                label="شرح بازدید "
                placeholder="شرح بازدید را وارد کنید"
                rows={3}
              />
            ) : (
              <TextareaInput
                rules={{
                  required: {
                    value: true,
                    message: 'شرح حادثه را وارد نمایید',
                  },
                }}
                name="accident_description"
                label="شرح حادثه "
                placeholder="شرح حادثه را وارد کنید"
                rows={3}
              />
            )}
            <TextareaInput
              rules={{
                required: {
                  value: true,
                  message: 'نظر کارشناسی را وارد نمایید',
                },
              }}
              name="adjuster_opinion"
              label="نظر کارشناسی"
              placeholder="نظر کارشناسی را وارد کنید"
              rows={6}
            />
          </Flex>
          <FixToBottom className={css({ bottom: 10 })}>
            <LoadingButton
              loading={getAdjusterOpinionLoading || postLoading}
              fullWidth
              type="submit"
              disabled={!methods?.formState?.isValid}
            >
              ثبت
            </LoadingButton>
          </FixToBottom>
        </form>
      </FormProvider>
    </Box>
  );
};
